<template>
  <div class="container">
    <div class="container mb50">
      <p v-if="isRequired('bunshou')">内容を入力して保存してください。（<span class="hissu">*</span>印は必須項目です。）</p>
      <ValidationObserver ref="observer" tag="form">
        <table class="table mt40 mb50">
          <tbody>
            <tr>
              <td>企業コード<span class="hissu" v-if="isRequired('enterpriseCode')">*</span></td>
              <td>
                <ValidationProvider v-slot="{ errors }"
                  :rules="`${ isRequired('enterpriseCode') ? 'required' : ''}|numeric|digits:16`" ref="enterpriseCodeIsCheck">
                  <input id="enterpriseCode" type="text" :name="itemName.enterpriseCode" class="form-control enterp-codeInput"
                    v-model="entity.enterpriseCode" :readonly="isReadonly('enterpriseCode')" autocomplete="off" @change="changeEnterpriseCode" @keyup.enter="changeEnterpriseCode" />
                  <span class="errMsg errInline" :class="{ displayNone: errors.length === 0 }">{{ errors[0] }}</span>
                </ValidationProvider>
              </td>
            </tr>
            <tr class="">
              <td>企業名称<span class="hissu" v-if="isRequired('enterpriseName')">*</span></td>
              <td>
                <ValidationProvider :rules="`${ isRequired('enterpriseName') ? 'required' : ''}|max:40`">
                  <input id="enterpriseName" type="text" :name="itemName.enterpriseName" class="form-control enterp-codeInput"
                    v-model="entity.enterpriseName" :readonly="isReadonly('enterpriseName')" autocomplete="off" />
                  <span class="errMsg errInline" v-if="isErrorEnterpriseName">企業コードが存在しません。</span>
                </ValidationProvider>
              </td>
            </tr>
            <tr>
              <td>自社拠点コード<span class="hissu" v-if="isRequired('sectionCode')">*</span></td>
              <td>
                <ValidationProvider v-slot="{ errors }"
                  :rules="`${ isRequired('sectionCode') ? 'required' : ''}|alpha_num|max:16`">
                  <input type="text" :name="itemName.sectionCode" class="form-control enterp-codeInput"
                    v-model="entity.sectionCode" :readonly="isReadonly('sectionCode')" autocomplete="off" />
                  <span class="errMsg errInline" :class="{ displayNone: errors.length === 0 }">{{ errors[0] }}</span>
                </ValidationProvider>
              </td>
              <td v-if="editMode === 'update' && entity.sectionCode !== itemName.honshaCode">
                <button id="editBtn" class="btn btn-sm btn-secondary w50" :class="this.permissionData.editBtn[this.$session.get('userDiv')]"
                  type="button" style="margin-top:0;" @click="clickEditBtn">
                  編集
                </button>
              </td>
              <td v-if="displayEditSectionCode">
                <ValidationProvider v-slot="{ errors }" rules="alpha_num|max:16">
                  <input id="editedSectionCode" type="text" :name="itemName.sectionCode"
                    class="form-control enterp-codeInput" v-model="editedSectionCode" autocomplete="off" />
                  <span class="errMsg errInline" :class="{ displayNone: errors.length === 0 }">{{ errors[0] }}</span>
                </ValidationProvider>
              </td>
            </tr>
            <tr>
              <td>自社拠点名称<span class="hissu" v-if="isRequired('sectionName')">*</span></td>
              <td>
                <ValidationProvider v-slot="{ errors }"
                  :rules="`${ isRequired('sectionName') ? 'required' : ''}|max:50`">
                  <input type="text" :name="itemName.sectionName" class="form-control enterp-codeInput"
                    v-model="entity.sectionName" :readonly="isReadonly('sectionName')" autocomplete="off" />
                  <span class="errMsg errInline" :class="{ displayNone: errors.length === 0 }">{{ errors[0] }}</span>
                </ValidationProvider>
              </td>
            </tr>
            <!--ユーザ権限がsuperAdmin、もしくは業界形態が「携帯」かつadminの場合に、キャリア店舗コードとキャリア店舗名称欄を表示する-->
            <tr v-if="isDisplay('dsShopCode')">
              <td>キャリア店舗コード<span class="hissu" v-if="isRequired('dsShopCode')">*</span></td>
              <td>
                <ValidationProvider v-slot="{ errors }"
                  :rules="`${ isRequired('dsShopCode') ? 'required' : ''}|docomo_num_digits:4`"  ref="dsShopCodeIsCheck">
                  <input id="dsShopCode" type="text" :name="itemName.dsShopCode" class="form-control enterp-codeInput"
                    v-model="dsShopCode" :readonly="isReadonly('dsShopCode')" autocomplete="off" @change="changeDsShopCode" @keyup.enter="changeDsShopCode" />
                  <span class="errMsg errInline" :class="{ displayNone: errors.length === 0 }">{{ errors[0] }}</span>
                </ValidationProvider>
              </td>
            </tr>
            <tr v-if="isDisplay('dsShopName')">
              <td>キャリア店舗名称<span class="hissu" v-if="isRequired('dsShopName')">*</span></td>
              <td>
                <ValidationProvider :rules="`${ isRequired('dsShopName') ? 'required' : ''}`">
                  <input id="dsShopName" type="text" :name="itemName.dsShopName" class="form-control enterp-codeInput"
                    v-model="dsShopName" :readonly="isReadonly('dsShopName')" autocomplete="off" />
                  <span class="errMsg errInline" v-if="isErrorDsDhopName">キャリア店舗コードが存在しません。</span>
                </ValidationProvider>
              </td>
            </tr>
          </tbody>
        </table>
      </ValidationObserver>
      <button class="btn btn-lg btn-primary w200" :class="this.permissionData.save[this.$session.get('userDiv')]"
        type="submit" style="margin-top:0;" @click="save">保存</button>
      <button class="btn btn-lg btn-primary w200" :class="this.permissionData.cancel[this.$session.get('userDiv')]"
        type="button" style="margin-top:0;" @click="cancel">キャンセル</button>
      <br>
      <br>
      <button class="btn btn-lg btn-primary w200" :class="this.permissionData.delete[this.$session.get('userDiv')]"
        type="submit" v-if="showDeleteBtn" @click="deleteSection">削除</button>
    </div><!-- .container mb50 -->
  </div><!-- .container -->
</template>

<script>
import { ValidationObserver, ValidationProvider } from 'vee-validate'

export default {
  name: 'section-edit',

  components: {
    ValidationProvider,
    ValidationObserver
  },

  props: {
    mode: {
      type: String,
      default: null
    },
    enterpriseCode: {
      type: String,
      default: null
    },
    sectionCode: {
      type: String,
      default: null
    }
  },

  data () {
    return {
      screenTitle: '[マスタ設定] 拠点情報設定',
      entity: {
        enterpriseCode: null,
        enterpriseName: null,
        sectionCode: null,
        sectionName: null,
        createDateTime: null
      },
      permissionData: {},
      editedSectionCode: null,
      dsShopCode: null,
      dsShopName: null,
      displayEditSectionCode: false,
      isErrorDsDhopName: false,
      isErrorEnterpriseName: false,
      itemName: {},
      editMode: this.mode ? this.mode : this.sectionCode ? 'update' : 'entry'
    }
  },

  mounted () {
    this.$emit('setScreenTitle', this.screenTitle)
  },

  computed: {
    showDeleteBtn () {
      if (this.$session.get('userDiv') !== 0) {
        return true
      } else if (this.$session.get('userDiv') === 0) {
        if (this.$session.get('enterpriseCode') !== this.entity.enterpriseCode || this.$session.get('enterpriseCode') === this.entity.enterpriseCode) {
          if (this.$session.get('sectionCode') !== this.entity.sectionCode) {
            return true
          }
        }
      }
      return false
    }
  },

  async created () {
    this.$emit('setMessage', null, false)
    this.permissionData = this.permission().sectionEdit[this.editMode]
    this.itemName = this.item()
    if (this.enterpriseCode && this.sectionCode) {
      var params = {
        enterpriseCode: this.enterpriseCode,
        sectionCode: this.sectionCode
      }
      // 拠点情報操作（取得）API
      await this.axios.get('/api/section/get', {
        params: params,
        headers: {
          'Authorization': this.$session.get('accessToken'),
          'Content-Type': 'application/json;charset=UTF-8',
          'Access-Control-Allow-Origin': '*'
        }
      }).then((response) => {
        this.entity = response.data[0]
      })

      var docomoParams = {
        enterpriseCode: this.enterpriseCode,
        sectionCode: this.sectionCode,
        dsShopCode: null
      }
      // キャリア拠点情報取得API
      await this.axios.post('/api/dsshop/get', docomoParams, {
        headers: {
          'Authorization': this.$session.get('accessToken'),
          'Content-Type': 'application/json;charset=UTF-8',
          'Access-Control-Allow-Origin': '*'
        }
      }).then((response) => {
        if (typeof response.data.dsShopName === 'undefined') {
          this.isErrorDsDhopName = false
        } else {
          this.dsShopCode = response.data.dsShopCode
          this.dsShopName = response.data.dsShopName
          this.isErrorDsDhopName = false
        }
      })
    }
  },

  methods: {
    isReadonly (item) {
      return this.permissionData[item][this.$session.get('userDiv')] === 'readonly'
    },
    isDisplay (item) {
      return this.$session.get('businessType') === 0 && this.permissionData[item][this.$session.get('userDiv')] !== 'displayNone'
    },
    isRequired (item) {
      return this.permissionData[item][this.$session.get('userDiv')] === ''
    },
    clickEditBtn () {
      this.displayEditSectionCode = true
    },

    /**
     * 企業コードの変更イベント
     */
    async changeEnterpriseCode () {
      this.$emit('setMessage', null, false)
      const enterpriseCodeIsCheck = await this.$refs.enterpriseCodeIsCheck.validate()
      if (!enterpriseCodeIsCheck.valid || !this.entity.enterpriseCode) {
        this.entity.enterpriseName = ''
        this.isErrorEnterpriseName = false
        return
      }
      var params = {
        enterpriseCode: this.entity.enterpriseCode,
        enterpriseCreateDateFrom: '',
        enterpriseCreateDateTo: ''
      }
      // 企業情報操作（取得）API
      await this.axios.get('/api/enterprise/get', {
        params: params,
        headers: {
          'Authorization': this.$session.get('accessToken'),
          'Content-Type': 'application/json;charset=UTF-8',
          'Access-Control-Allow-Origin': '*'
        }
      }).then((response) => {
        if (response.data.length === 0) {
          this.entity.enterpriseName = ''
          this.isErrorEnterpriseName = true
        } else {
          this.entity.enterpriseName = response.data[0].enterpriseName
          this.isErrorEnterpriseName = false
        }
      })
    },

    /**
     * キャリア拠点コードの変更イベント
     */
    async changeDsShopCode () {
      this.$emit('setMessage', null, false)
      const dsShopCodeIsCheck = await this.$refs.dsShopCodeIsCheck.validate()
      if (!dsShopCodeIsCheck.valid || !this.dsShopCode) {
        this.dsShopName = ''
        this.isErrorDsDhopName = false
        return
      }
      var params = {
        enterpriseCode: null,
        sectionCode: null,
        dsShopCode: this.dsShopCode
      }
      // キャリア拠点情報取得API
      await this.axios.post('/api/dsshop/get', params, {
        headers: {
          'Authorization': this.$session.get('accessToken'),
          'Content-Type': 'application/json;charset=UTF-8',
          'Access-Control-Allow-Origin': '*'
        }
      }).then((response) => {
        if (typeof response.data.dsShopName === 'undefined') {
          this.dsShopName = ''
          this.isErrorDsDhopName = true
        } else {
          this.dsShopName = response.data.dsShopName
          this.isErrorDsDhopName = false
        }
      })
    },

    /**
     * 保存処理
     */
    async save () {
      this.$emit('setMessage', null, false)
      const isValid = await this.$refs.observer.validate()
      if (!isValid || this.isErrorDsDhopName || this.isErrorEnterpriseName) {
        return
      }

      this.entity.editedSectionCode = this.editedSectionCode
      // 保存処理：拠点情報操作（登録・更新）API
      await this.axios.post('/api/section/' + this.editMode, this.entity, {
        headers: {
          'Authorization': this.$session.get('accessToken'),
          'Content-Type': 'application/json;charset=UTF-8',
          'Access-Control-Allow-Origin': '*'
        }
      })

      // 拠点情報の登録更新に成功し、キャリア店舗コードに入力がある場合
      if (this.dsShopCode) {
        var dsShopParams = {
          enterpriseCode: this.entity.enterpriseCode,
          sectionCode: this.entity.sectionCode,
          dsShopCode: this.dsShopCode
        }
        // キャリア拠点情報更新API
        await this.axios.post('/api/dsshop/update', dsShopParams, {
          headers: {
            'Authorization': this.$session.get('accessToken'),
            'Content-Type': 'application/json;charset=UTF-8',
            'Access-Control-Allow-Origin': '*'
          }
        })
      }

      // 拠点コードを変更した場合
      if (this.editedSectionCode !== null) {
        this.displayEditSectionCode = false
        var params = {
          enterpriseCode: this.enterpriseCode,
          sectionCode: this.editedSectionCode
        }
        // 拠点情報操作（取得）API
        var response = await this.axios.get('/api/section/get', {
          params: params,
          headers: {
            'Authorization': this.$session.get('accessToken'),
            'Content-Type': 'application/json;charset=UTF-8',
            'Access-Control-Allow-Origin': '*'
          }
        })
        this.entity = response.data[0]
        this.editedSectionCode = null
      }
      // 保存完了
      this.$emit('setMessage', '保存処理が完了しました。', false)
    },

    /**
     * キャンセルボタン押下処理
     */
    cancel () {
      // キャンセル処理：拠点情報一覧画面に遷移
      this.$router.push({ name: 'section-list' })
    },

    /**
     * 削除ボタン押下処理
     */
    async deleteSection () {
      if (confirm('削除してもよろしいですか？')) {
        // 削除処理：拠点情報操作（削除）API
        await this.axios.post('/api/section/delete', {
          'enterpriseCode': this.enterpriseCode,
          'sectionCode': this.sectionCode
        }, {
          headers: {
            'Authorization': this.$session.get('accessToken'),
            'Content-Type': 'application/json;charset=UTF-8',
            'Access-Control-Allow-Origin': '*'
          }
        }).then((response) => {
          this.$router.push({ name: 'section-list', params: { message: '削除が完了しました。' } })
        })
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>



// WEBPACK FOOTER //
// src/components/pages/SectionEdit.vue